import React, { Component } from "react";
import TournamentDetails from "../../components/settings/TournamentDetails";

class TournamentDetailsContainer extends Component {
  state = {
    place: "",
    placeSet: false,
  };

  componentDidMount = () => {
    this.setState({ place: this.props.tournament.place || "", placeSet: true });
  };

  handleSportChange = (e, value) => {
    let toUpdate = {};
    toUpdate["sportId"] = value ? value.id : null;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleGenderChange = (e) => {
    let toUpdate = {};
    toUpdate["gender"] = e.target.value;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleAgeChange = (e, value) => {
    let toUpdate = {};
    toUpdate["age"] = value;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleLevelChange = (value) => {
    let toUpdate = {};
    toUpdate["level"] = value;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handlePlaceSearchChange = (e) => {
    let toUpdate = {};
    toUpdate["place"] = e.target.value;
    this.setState(toUpdate);
  };

  handleSetPlace = (newValue) => {
    let value = newValue || {};
    let name =
      (value.structured_formatting || {}).main_text || value.description || "";
    let secondaryName =
      (value.structured_formatting || {}).secondary_text ||
      value.description ||
      "";
    let placeId = value.place_id || null;
    let reference = value.reference || null;
    let toUpdate = {
      place: name,
      placeSecondaryName: secondaryName,
      placeId: placeId,
      placeReference: reference,
    };
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleCountryChange = (e) => {
    let toUpdate = {};
    toUpdate["country"] = e.target.value;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  render() {
    return this.state.placeSet ? (
      <TournamentDetails
        tournament={this.props.tournament}
        handleSportChange={this.handleSportChange}
        sport={
          this.props.tournament.sportId !== undefined &&
          this.props.tournament.sportId !== null
            ? this.props.tournament.sportId
            : null
        }
        handleGenderChange={this.handleGenderChange}
        gender={this.props.tournament.gender || []}
        handleAgeChange={this.handleAgeChange}
        age={this.props.tournament.age || [12, 30]}
        handleLevelChange={this.handleLevelChange}
        level={
          this.props.tournament.level !== undefined
            ? this.props.tournament.level
            : null
        }
        setPlaceName={this.handleSetPlace}
        // place={
        //   this.props.tournament.place !== undefined
        //     ? this.props.tournament.place
        //     : null
        // }
        handlePlaceSearchChange={this.handlePlaceSearchChange}
        placeSearch={this.state.place}
        handleCountryChange={this.handleCountryChange}
        country={
          this.props.tournament.country !== undefined
            ? this.props.tournament.country
            : ""
        }
      />
    ) : null;
  }
}

export default TournamentDetailsContainer;
